import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Chip from "@material-ui/core/Chip";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { utilGetVehicleImage } from "../../common/util";
let regType = "";
const VehicleListView = ({ vehiclesList }) => {
  
  return (
    <div>
      {vehiclesList.map(item => {
        let src = utilGetVehicleImage(item.vehCategory);
        return (
          <List style={styles.root}>
            <ListItem
              alignItems="flex-start"
              style={{ marginTop: 15, backgroundColor: "white" }}
            >
              <img src={src} height={70} width={100} />
              <ListItemText
                primary={`Vehicle Id : ${item.name}`}
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      className={styles.inline}
                      color="textPrimary"
                    >
                      <span>{`Next Inspection : ${item.nextInspectionDue}`}</span>
                      <span
                        style={{ marginLeft: 15 }}
                      >{`Defect Count : ${item.defectCount}`}</span>
                    </Typography>
                    <Typography
                      component="span"
                      className={styles.inline}
                      color="textPrimary"
                    >
                      <span>{`VIN : ${item.VIN}`}</span>
                      <span
                        style={{ marginLeft: 15 }}
                      >{`Make : ${item.make}`}</span>
                      <span style={{ marginLeft: 15 }}>
                        {`Model : ${item.model}`}
                      </span>
                      {item.deactivateBIT && item.regType !== "FEDERAL" && (
                        <span style={{ marginLeft: "25%" }}>
                          <Chip label="BIT Deactivated" color="secondary" />
                        </span>
                      )}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        );
      })}
    </div>
  );
};
const styles = {
  btn: {
    backgroundColor: "skyBlue"
  },
  root: {
    width: "100%",
    maxWidth: 500
    // backgroundColor: 'white',
  },
  inline: {
    display: "inline"
  }
};
export default VehicleListView;



// WEBPACK FOOTER //
// ./src/components/Dashboard/vehisleListView.js